import { EntityDefinition } from '@/types/crud';

export const navigationModuleEntity: EntityDefinition = {
  name: 'navigation-module',
  displayName: 'Navigation Modules',
  displayNameSingular: 'Navigation Module',
  apiEndpoint: '/navigation/modules',

  idField: 'id',
  nameField: 'display_name',
  fields: [
    {
      key: 'module_code',
      label: 'Module Code',
      type: 'text',
      required: true,
      placeholder: 'Enter module code (e.g., USER_MANAGEMENT)',
      validation: {
        minLength: 2,
        maxLength: 50,
        pattern: '^[A-Z_]+$'
      }
    },
    {
      key: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'Enter display name',
      validation: {
        minLength: 2,
        maxLength: 100
      }
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      placeholder: 'Enter module description',
      validation: {
        maxLength: 500
      }
    },
    {
      key: 'icon',
      label: 'Icon',
      type: 'text',
      required: false,
      placeholder: 'Enter icon name (e.g., users, cog)',
      validation: {
        maxLength: 50
      }
    },
    {
      key: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      required: true,
      placeholder: 'Enter sort order',
      defaultValue: 0,
      hidden: true, // Hide from table display
      validation: {
        min: 0
      }
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'boolean',
      required: true,
      defaultValue: true
    },
    {
      key: 'is_admin',
      label: 'Admin Module',
      type: 'boolean',
      required: false,
      defaultValue: false,
      helpText: 'If enabled and this is a root module, it appears in the admin section of left sidebar.'
    },
    {
      key: 'is_system_module',
      label: 'System Module',
      type: 'boolean',
      required: false,
      defaultValue: false,
      hidden: true // Hide from table display
    },
    {
      key: 'parent_module_id',
      label: 'Parent Module',
      type: 'select',
      required: false,
      placeholder: 'Select parent module (optional)',
      options: [], // Will be populated dynamically
      helpText: 'Leave empty for top-level modules, or select a parent to create sub-modules',
      render: (value: any, _item: any) => {
        // This will be handled by the NavigationManagementPage with dynamic options
        return value || 'Top Level';
      }
    },
    
  ],
  tableColumns: [
    { key: 'module_code', label: 'Module Code', sortable: true },
    { key: 'display_name', label: 'Display Name', sortable: true },
    { key: 'is_admin', label: 'Admin Module', sortable: true },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'icon', label: 'Icon', sortable: true },
    { key: 'parent_module_id', label: 'Parent Module', sortable: true },
    { key: 'sort_order', label: 'Sort Order', sortable: true },
    { key: 'is_active', label: 'Active', sortable: true },
    { key: 'created_at', label: 'Created', sortable: true }
  ],
  searchFields: ['module_code', 'display_name', 'description'],
  defaultSort: { field: 'sort_order', direction: 'asc' },
  copyable: true,
  deletable: false,
  customActions: [
    {
      key: 'toggle_status',
      action: 'toggle_status',
      label: 'Toggle Status',
      icon: 'EyeIcon',
      variant: 'secondary',
      onClick: () => {}
    },
    {
      key: 'hard_delete',
      action: 'hard_delete',
      label: 'Hard Delete',
      icon: 'TrashIcon',
      variant: 'danger',
      onClick: () => {}
    }
  ]
};
